import { spaceProp, getVariantToken } from '@koaly/mixins';
import styled from 'styled-components';

const Dot = styled.span `
  display: inline-flex;
  align-self: center;
  ${({ size }) => spaceProp(size, 'width')};
  ${({ size }) => spaceProp(size, 'height')};
  text-align: center;
  border-radius: 50%;
  line-height: 1;
  background: ${getVariantToken('dot', 'backgroundColor')};
  color: ${getVariantToken('dot', 'color')};
  font-family: ${getVariantToken('dot', 'fontFamily')};
  ${({ padding }) => spaceProp(padding, 'padding')};
  svg {
    width: auto;
    height: 100%;
  }
`;

export { Dot };
//# sourceMappingURL=Dot.js.map
